/** 뒤로가기
 *
 */
export const historyBack = () => {
    window.history.back();
};

/**
 * camelcase -> kebabize
 * @param {*} str
 * @returns
 */
export const kebabize = (str) => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '-' : '') + $.toLowerCase());

/**
 * 초 => 00:00:00 으로변경
 * @param {*} seconds
 * @returns string
 */
export const getTimeStringSeconds = (seconds) => {
    var hour, min, sec;
    hour = parseInt(seconds / 3600);
    min = parseInt((seconds % 3600) / 60);
    sec = seconds % 60;
    if (hour.toString().length == 1) hour = '0' + hour;
    if (min.toString().length == 1) min = '0' + min;
    if (sec.toString().length == 1) sec = '0' + sec;
    return (hour !== '00' ? hour + ':' : '') + min + ':' + sec;
};

/**
 * Milliseconds => 00:00:00 Format
 * @param {*} milliseconds
 * @returns string
 */
export const getTimeStringMilliseconds = (milliseconds) => {
    var hour, min, sec;
    var totalSeconds = parseInt(milliseconds / 1000);
    hour = parseInt(totalSeconds / 3600);
    min = parseInt((totalSeconds % 3600) / 60);
    sec = totalSeconds % 60;
    if (hour.toString().length == 1) hour = '0' + hour;
    if (min.toString().length == 1) min = '0' + min;
    if (sec.toString().length == 1) sec = '0' + sec;
    return (hour !== '00' ? hour + ':' : '') + min + ':' + sec;
};

/**
 * 초 => n시 n분 n초 로변경
 * @param {*} seconds
 * @returns string
 */
export const getTimeStringSecondsKor = (seconds) => {
    let hour, min, sec;
    hour = parseInt(seconds / 3600);
    min = parseInt((seconds % 3600) / 60);
    sec = parseInt(seconds % 60);
    // if (hour.toString().length == 1) hour = '0' + hour;
    // if (min.toString().length == 1) min = '0' + min;
    // if (sec.toString().length == 1) sec = '0' + sec;
    return `${hour === 0 ? '' : `${hour}시간 `}${min === 0 ? '' : `${min}분 `}${sec === 0 ? '' : `${sec}초`}`;
};
/**
 *  n시 n분 n초 => 초 로변경
 * @param {*} seconds
 * @returns string
 */
export const timeStringSecondsKorToSec = (str) => {
    if (!str) return 0;
    let secTime = 0;
    let tmpStr = str;
    if (tmpStr.indexOf('시간') > -1) {
        try {
            let tmp = tmpStr.split('시간');
            secTime = Number(tmp[0]) * 3600;
            tmpStr = tmp[1];
        } catch (error) {
            // console.log('error');
        }
    }
    if (tmpStr.indexOf('분') > -1) {
        try {
            let tmp = tmpStr.split('분');
            secTime += Number(tmp[0]) * 60;
            tmpStr = tmp[1];
        } catch (error) {
            // console.log('error');
        }
    }
    if (tmpStr.indexOf('초') > -1) {
        try {
            let tmp = tmpStr.split('초');
            secTime += Number(tmp[0]);
            tmpStr = tmp[1];
        } catch (error) {
            // console.log('error');
        }
    }
    return secTime;
};

/**
 * 태그제거
 * @param {*} str
 * @returns string
 */
export const stripTags = (str) => {
    if (str) {
        str = str.replace(/(<([^>]+)>)/gi, ''); // 태그 제거
        str = str.replace(/\s\s+/g, ' '); // 연달아 있는 줄바꿈, 공백, 탭을 공백 1개로 줄임
        str = str.replaceAll('&nbsp', '');
    }
    return str;
};

export const textAreaResize = () => {
    const txHeight = 26;
    const tx = document.getElementsByTagName('textarea');

    for (let i = 0; i < tx.length; i++) {
        if (tx[i].value == '') {
            tx[i].style.height = 'auto';
            tx[i].style.height = txHeight + 'px';
            tx[i].style.overflowY = 'hidden';
        } else {
            tx[i].style.height = 'auto';
            tx[i].style.height = tx[i].scrollHeight + 'px';
            tx[i].style.overflowY = 'hidden';
        }
        tx[i].removeEventListener('input', OnInput, false);
        tx[i].addEventListener('input', OnInput, false);
    }

    function OnInput(e) {
        this.style.height = 0;
        this.style.height = this.scrollHeight + 'px';
    }
};

/**
 * 비번 유효성 검사
 * @param {*} str
 * @returns string
 */
export const checkPassword = (txt) => {
    if (/^(?=.*[a-zA-Z])(?=.*\d)(?=.*\W).{5,20}$/.test(txt)) {
        return true;
    }
    return false;
};

/**
 * kread 지수에 따른 학년
 * @param {*} str
 * @returns string
 */
export const getKreadGrade = (kread) => {
    // console.log('--getKreadGrade--')
    if (kread < 1300) return '초등 5, 6​';
    if (kread >= 1300 && kread < 1400) return '예비중, 중1​';
    if (kread >= 1400 && kread < 1500) return '중1, 2​ ';
    if (kread >= 1500) return '중2, 3​';

    // if (kread > 1200 && kread < 1299) {
    //     return '초등 6학년';
    // } else if (kread >= 1300 && kread < 1399) {
    //     return '중학교 1학년';
    // } else if (kread >= 1400 && kread < 1499) {
    //     return '중학교 2학년';
    // } else if (kread >= 1500 && kread < 1599) {
    //     return '중학교 3학년';
    // } else if (kread >= 1600 && kread < 1699) {
    //     return '고등학교 1학년';
    // } else if (kread >= 1700 && kread < 1799) {
    //     return '고등학교 2학년';
    // } else if (kread >= 1800) {
    //     return '고등학교 3학년';
    // } else {
    //     return '';
    // }
};
/**
 * 원각 문자로 변환한 정답 반환
 * @param {*} str
 * @returns string
 */
export const getCircularAnswer = (answer) => {
    if (answer === '1' || answer === 1) {
        return '①';
    } else if (answer === '2' || answer === 2) {
        return '②';
    } else if (answer === '3' || answer === 3) {
        return '③';
    } else if (answer === '4' || answer === 4) {
        return '④';
    } else if (answer === '5' || answer === 5) {
        return '⑤';
    }
};

/**
 * 원각 문자를 숫자로 변환한 정답 반환
 * @param {*} str
 * @returns string
 */
export const getNumberAnswer = (answer) => {
    // console.log(answer);
    if (answer === '①') {
        return 1;
    } else if (answer === '②') {
        return 2;
    } else if (answer === '③') {
        return 3;
    } else if (answer === '④') {
        return 4;
    } else if (answer === '⑤') {
        return 5;
    }
};

/**
 * 작은 따옴표 '' 형태를 ‘’ 형태로 치환
 * @param {*} str
 * @returns string
 */
export const replaceQuotes = (text) => {
    const characters = text.split('');
    let isOddQuote = true;

    for (let i = 0; i < characters.length; i++) {
        if (characters[i] === "'") {
            if (isOddQuote) {
                characters[i] = '‘';
            } else {
                characters[i] = '’';
            }
            isOddQuote = !isOddQuote;
        }
    }
    return characters.join('');
};

/**
 * 로컬에서만 로그 작동하도록 사용하는 훅
 * @returns boolean
 */
export const useLocalLog = () => {
    const isLocal = process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development';
    return isLocal;
};
